import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MothershipBrain from './MothershipBrain';

// Persist panel open state across page navigation
const getPanelOpen = () => sessionStorage.getItem('ms-brain-open') === 'true';
const setPanelOpenStorage = (open: boolean) => sessionStorage.setItem('ms-brain-open', String(open));

// Pages where the floating tools should be hidden
const HIDDEN_ON_PAGES = ['/dropgen'];

export function FloatingTools() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(getPanelOpen);

  // Hide on certain pages
  const isHidden = HIDDEN_ON_PAGES.some(page => location.pathname.startsWith(page));

  // Toggle MothershipBrain
  const toggleBrain = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    setPanelOpenStorage(newState);
  };

  const closeBrain = () => {
    setIsOpen(false);
    setPanelOpenStorage(false);
  };

  // Restore state on mount
  useEffect(() => {
    if (getPanelOpen()) {
      setIsOpen(true);
    }
  }, []);

  // Don't render on hidden pages
  if (isHidden) return null;

  return (
    <>
      {/* Floating saucer button - hidden when panel is open */}
      {!isOpen && (
        <div className="floating-tools-container fixed bottom-6 right-4 z-[99999]">
          <button
            onClick={toggleBrain}
            className="group w-16 h-16 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 flex items-center justify-center relative overflow-hidden"
            style={{
              background: 'transparent',
              boxShadow: '0 0 20px rgba(139, 92, 246, 0.4), 0 0 40px rgba(236, 72, 153, 0.2)'
            }}
          >
            {/* Glow ring behind saucer */}
            <div
              className="absolute inset-0 rounded-full opacity-60"
              style={{
                background: 'radial-gradient(circle, rgba(139,92,246,0.4) 0%, rgba(236,72,153,0.3) 50%, transparent 70%)',
                animation: 'pulse 2s ease-in-out infinite'
              }}
            />

            {/* Saucer image */}
            <img
              src="/assets/saucer.png"
              alt="Mothership AI"
              className="w-14 h-14 object-contain relative z-10 transition-all duration-300 group-hover:drop-shadow-[0_0_12px_rgba(139,92,246,0.8)]"
              style={{ filter: 'drop-shadow(0 0 6px rgba(139,92,246,0.6))' }}
            />

            {/* Status indicator dot */}
            <span className="absolute top-0 right-0 w-3 h-3 rounded-full border-2 border-[#0d1117] bg-purple-500" />

            <style>{`
              @keyframes pulse {
                0%, 100% { opacity: 0.4; transform: scale(1); }
                50% { opacity: 0.7; transform: scale(1.05); }
              }
            `}</style>
          </button>
        </div>
      )}

      {/* MothershipBrain - opens in popup mode by default */}
      <MothershipBrain
        isOpen={isOpen}
        onClose={closeBrain}
        startInMiniMode={false}
      />
    </>
  );
}
